export enum StatusAgendamentoEnum {
  PENDENTE = 1,
  CONFIRMADO = 2,
  CANCELADO = 3,
  REALIZADO = 4,
}
